module.exports = __webpack_public_path__ + "img/map-view.3d94375e.svg";